export default "/images/truck-with-boxes.png?db023892b8426589a70883fcff015c77";